import { defineStyleConfig, ComponentStyleConfig } from '@chakra-ui/react';

export const linkTheme: ComponentStyleConfig = defineStyleConfig({
  baseStyle: {
    color: 'blue.600',
    fontWeight: 'medium',

    _dark: {
      color: 'blue.300'
    }
  }
});
